{
	"name": "Voice assistant agent",
	"meta": {
		"templateCredsSetupCompleted": false,
		"templateId": "voice_assistant_agent_with_telegram"
	},
	"nodes": [
		{
			"parameters": {
				"updates": ["message"],
				"additionalFields": {
					"download": false,
					"userIds": "YOUR_USER_ID"
				}
			},
			"id": "0c402bdc-7fa2-4fa1-96d6-f02853cfdaa1",
			"name": "Telegram Message Trigger",
			"type": "n8n-nodes-base.telegramTrigger",
			"typeVersion": 1.2,
			"position": [-192, 0],
			"webhookId": "55acc711-c248-4ac9-b6cd-e295c2d33f4b",
			"credentials": {}
		},
		{
			"parameters": {
				"sessionIdType": "customKey",
				"sessionKey": "={{ $('Telegram Message Trigger').first().json.message.chat.id }}",
				"contextWindowLength": 10
			},
			"id": "30bef40d-efbe-4920-acad-ce9a42c0061c",
			"name": "Memory",
			"type": "@n8n/n8n-nodes-langchain.memoryBufferWindow",
			"typeVersion": 1.3,
			"position": [752, 288]
		},
		{
			"parameters": {
				"chatId": "={{ $('Telegram Message Trigger').first().json.message.chat.id }}",
				"text": "={{ $json.output }}",
				"additionalFields": {}
			},
			"type": "n8n-nodes-base.telegram",
			"typeVersion": 1.2,
			"position": [1056, 0],
			"id": "7dea5c17-bfdb-4874-918b-a6583298efa2",
			"name": "Reply in Telegram",
			"webhookId": "b96b7a41-9806-455f-b72e-00aa638eda71",
			"credentials": {}
		},
		{
			"parameters": {
				"resource": "file",
				"fileId": "={{ $json.message.voice.file_id }}",
				"additionalFields": {}
			},
			"type": "n8n-nodes-base.telegram",
			"typeVersion": 1.2,
			"position": [256, -96],
			"id": "66219c83-6371-4cc6-ad43-57cee44f52da",
			"name": "Get a file",
			"webhookId": "e0769871-efe3-49da-81a5-2f88a6fdd33f",
			"credentials": {}
		},
		{
			"parameters": {
				"conditions": {
					"options": {
						"caseSensitive": true,
						"leftValue": "",
						"typeValidation": "strict",
						"version": 2
					},
					"conditions": [
						{
							"id": "2b538077-d3d3-4713-b973-68748313ff97",
							"leftValue": "={{ $json.message.voice }}",
							"rightValue": "",
							"operator": {
								"type": "object",
								"operation": "notEmpty",
								"singleValue": true
							}
						}
					],
					"combinator": "and"
				},
				"options": {}
			},
			"type": "n8n-nodes-base.if",
			"typeVersion": 2.2,
			"position": [32, 0],
			"id": "3a1a7f7f-f122-438d-a0f2-1e80d1072dba",
			"name": "Check if Audio file"
		},
		{
			"parameters": {
				"resource": "audio",
				"operation": "transcribe",
				"options": {}
			},
			"type": "@n8n/n8n-nodes-langchain.openAi",
			"typeVersion": 1.8,
			"position": [480, -96],
			"id": "6f314aef-7ff1-4211-8656-e2c1f8fea374",
			"name": "Transcribe audio",
			"credentials": {}
		},
		{
			"parameters": {
				"assignments": {
					"assignments": [
						{
							"id": "eb912219-2436-4f04-8ffc-c1c20eb07344",
							"name": "text",
							"value": "={{ $json.message.text }}",
							"type": "string"
						}
					]
				},
				"options": {}
			},
			"type": "n8n-nodes-base.set",
			"typeVersion": 3.4,
			"position": [480, 96],
			"id": "2e9b0ca3-2a0f-441d-89a0-28365c5ba3ef",
			"name": "Set field"
		},
		{
			"parameters": {
				"model": {
					"__rl": true,
					"value": "gpt-4.1-mini",
					"mode": "list",
					"cachedResultName": "gpt-4.1-mini"
				},
				"options": {}
			},
			"id": "61f3b0a0-210a-4eaa-91b5-e381d5f56754",
			"name": "Model",
			"type": "@n8n/n8n-nodes-langchain.lmChatOpenAi",
			"typeVersion": 1.2,
			"position": [624, 288],
			"credentials": {}
		},
		{
			"parameters": {
				"promptType": "define",
				"text": "={{ $json.text || $json.message.text }}",
				"options": {
					"systemMessage": "=# Telegram Personal AI Assistant System Prompt\n\nYou are a helpful personal AI assistant that communicates with users through Telegram.\n\n## Your Capabilities\n\nYou can help users with:\n- **General conversation** - Answer questions and provide information\n\n## Communication Style\n\n### Response Format\n- Keep responses conversational and friendly\n- Use appropriate length for Telegram (not too long)\n- Be helpful and informative\n- Match the user's tone and communication style\n\n### Voice Message Handling\n- When users send voice messages, respond naturally as if they spoke to you directly\n- Don't mention that their message was transcribed\n- Respond in a conversational way that flows naturally\n\n\n## Context Awareness\n\n- Remember the current date and time: **Today is {{ $now.format('cccc') }} the {{ $now.format('yyyy-MM-dd HH:mm') }}**\n- Use this information to provide relevant, timely responses\n- Reference \"today\", \"tomorrow\", \"this week\" appropriately\n\n## Important Guidelines\n\n- Maintain conversation context using the memory system\n- Ask clarifying questions when requests are ambiguous\n- Respect privacy - only access information when relevant to the request\n- If you can't help with something, suggest alternatives or redirect to your available capabilities\n\nRemember: You're a personal assistant, so be personable, helpful, and focused on making the user's day easier and more organized.\n\nToday is {{ $now.format('cccc') }} the {{ $now.format('yyyy-MM-dd HH:mm') }}."
				}
			},
			"id": "f958d2f6-6602-4443-bfae-ef628af09b84",
			"name": "Assistant Agent",
			"type": "@n8n/n8n-nodes-langchain.agent",
			"typeVersion": 2.2,
			"position": [704, 0]
		},
		{
			"parameters": {
				"content": "## Start here!\n@[youtube](aaOLJ2mUoVk)",
				"height": 320,
				"width": 464,
				"color": 5
			},
			"type": "n8n-nodes-base.stickyNote",
			"position": [-736, -80],
			"typeVersion": 1,
			"id": "cd6f0a09-148c-46e3-9858-11645de3a802",
			"name": "Sticky Note1"
		}
	],
	"connections": {
		"Telegram Message Trigger": {
			"main": [
				[
					{
						"node": "Check if Audio file",
						"type": "main",
						"index": 0
					}
				]
			]
		},
		"Memory": {
			"ai_memory": [
				[
					{
						"node": "Assistant Agent",
						"type": "ai_memory",
						"index": 0
					}
				]
			]
		},
		"Get a file": {
			"main": [
				[
					{
						"node": "Transcribe audio",
						"type": "main",
						"index": 0
					}
				]
			]
		},
		"Check if Audio file": {
			"main": [
				[
					{
						"node": "Get a file",
						"type": "main",
						"index": 0
					}
				],
				[
					{
						"node": "Set field",
						"type": "main",
						"index": 0
					}
				]
			]
		},
		"Transcribe audio": {
			"main": [
				[
					{
						"node": "Assistant Agent",
						"type": "main",
						"index": 0
					}
				]
			]
		},
		"Set field": {
			"main": [
				[
					{
						"node": "Assistant Agent",
						"type": "main",
						"index": 0
					}
				]
			]
		},
		"Model": {
			"ai_languageModel": [
				[
					{
						"node": "Assistant Agent",
						"type": "ai_languageModel",
						"index": 0
					}
				]
			]
		},
		"Assistant Agent": {
			"main": [
				[
					{
						"node": "Reply in Telegram",
						"type": "main",
						"index": 0
					}
				]
			]
		}
	},
	"pinData": {},
	"active": false,
	"settings": {
		"executionOrder": "v1"
	},
	"tags": []
}
